<div appBannerNotification [alertLevel]="alertLevel">
  <div *ngIf="showIcon" class="notificationIcon">
    <mat-icon appBannerNotificationIcon [alertLevel]="alertLevel"></mat-icon>
  </div>
  <div class="notificationMessage">
    <ng-content select="[message]"></ng-content>
  </div>
  <ng-content></ng-content>
</div>
